export default "__VITE_ASSET__0U43Fpxf__"